module.exports = __webpack_public_path__ + "img/bens.da1fef23.png";